import { render, staticRenderFns } from "./AboutStep.vue?vue&type=template&id=94d3720e&"
import script from "./AboutStep.vue?vue&type=script&lang=js&"
export * from "./AboutStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94d3720e')) {
      api.createRecord('94d3720e', component.options)
    } else {
      api.reload('94d3720e', component.options)
    }
    module.hot.accept("./AboutStep.vue?vue&type=template&id=94d3720e&", function () {
      api.rerender('94d3720e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Onboarding/Components/AboutStep.vue"
export default component.exports